var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" 宿泊日から"+_vm._s(_vm.data.bookingFromMonths)+"か月"+_vm._s(_vm.data.bookingFromDays)+"日前 ")])}
var staticRenderFns = []

export { render, staticRenderFns }